<template>
  <div>
    <vxe-grid
      ref="specFabricTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :columns="tableColumns"
      :data="tableData"
      size="mini"
      resizable
      :checkbox-config="{ highlight: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEditDialog', { optType: 'edit', data: row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
  methods: {
    del({ pdCostsOrderGoodsPackingCode }) {
      this.$emit('del', pdCostsOrderGoodsPackingCode)
    },
    getCheckboxRecords(type = 'code') {
      const $table = this.$refs.specFabricTable
      const data = $table.getCheckboxRecords()
      if (!data || !data.length) {
        return
      }
      if (type == 'code') {
        return data.map((item) => item.pdCostsOrderGoodsPackingCode)
      }
      return data
    },
  },
}
</script>
